import { useVisit } from '../VisitContext';
import { GoalsAndInterventionsForVisit } from '../../careplanning/goals-interventions/GoalsAndInterventionsForVisit';
import { useVisitEvaluation } from '~/features/frequencies/evaluations/VisitEvaluationContext';
import { FrequenciesForVisit } from '~/features/frequencies/FrequenciesForVisit';
import { VisitOrderDrawer } from '../orders/VisitOrderDrawer';

export function VisitEvaluationToolbar() {
	const { performingUserId, visitDisciplineId } = useVisit();
	const evaluationContext = useVisitEvaluation();

	if (!evaluationContext || evaluationContext.isLoading || !evaluationContext.fullOrder.invariants.canBeEdited) {
		return null;
	}

	return (
		<div className="flex items-center space-x-2">
			<VisitOrderDrawer fullOrder={evaluationContext.fullOrder} />
			<GoalsAndInterventionsForVisit fullOrder={evaluationContext.fullOrder} />
			<FrequenciesForVisit
				fullOrder={evaluationContext.fullOrder}
				suggestedFrequencyPlan={evaluationContext.suggestedFrequencyPlan}
				defaultAssignment={{
					userId: performingUserId,
					disciplineId: visitDisciplineId
				}}
			/>
		</div>
	);
}
